import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';

import { App } from 'CorePackage/MainModule/components/App';

import 'CorePackage/MainModule/styles/main.scss';

/* Локально нужно создать .env.local
внутрь положить
REACT_APP_SENTRY_DSN=dsn_для_Sentry
REACT_APP_SENTRY_ENVIRONMENT=development
____________________________________________
На проде создать .env.production
REACT_APP_SENTRY_DSN=dsn_для_Sentry
REACT_APP_SENTRY_ENVIRONMENT=production
*/

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  });
}

const RootApp = sentryDsn ? Sentry.withProfiler(App) : App;

ReactDOM.render(<RootApp />, document.getElementById('root'));
